import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DEFAULT_STYLE_OPTIONS } from '../../../../../aumico-lib-annualreport-fe/src/lib';
import { OrganizationSettings } from '../../interfaces/organization-settings.interface';

@UntilDestroy()
@Component({
    selector: 'aumico-organization-settings-page',
    templateUrl: './organization-settings.page.html',
    styleUrls: ['./organization-settings.page.scss'],
})
export class OrganizationSettingsPage implements OnInit, OnChanges {
    @Input() organizationSettings: OrganizationSettings | undefined;
    form: FormGroup;
    currentYearDate: Date;
    previousYearDate: Date;

    constructor(private fb: FormBuilder) {
        const today = new Date();
        this.currentYearDate = today;
        this.previousYearDate = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate()); // Subtract one year
    }

    ngOnInit(): void {
        this.initializeForm();

        // React to form changes and emit the new values
        this.form.valueChanges.subscribe((value) => {
            if (this.organizationSettings) {
                this.organizationSettings = value.styleOptions;
            }
            this.onOrganizationSettingsChanged.emit(this.organizationSettings);
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['organizationSettings'] && this.organizationSettings) {
            this.patchForm();
        }
    }

    initializeForm(): void {
        this.form = this.fb.group({
            styleOptions: this.fb.group({
                textColor: [this.organizationSettings?.textColor || DEFAULT_STYLE_OPTIONS.textColor],
                backgroundColor: [this.organizationSettings?.backgroundColor || DEFAULT_STYLE_OPTIONS.backgroundColor],
                titleColor: [this.organizationSettings?.titleColor || DEFAULT_STYLE_OPTIONS.titleColor],
            }),
        });
    }

    patchForm(): void {
        if (this.organizationSettings) {
            this.form?.patchValue({
                styleOptions: {
                    textColor: this.organizationSettings.textColor || DEFAULT_STYLE_OPTIONS.textColor,
                    backgroundColor: this.organizationSettings.backgroundColor || DEFAULT_STYLE_OPTIONS.backgroundColor,
                    titleColor: this.organizationSettings.titleColor || DEFAULT_STYLE_OPTIONS.titleColor,
                },
            });
        }
    }

    @Output() onOrganizationSettingsChanged = new EventEmitter<OrganizationSettings>();
}
